(function () {
  var MOBILE_BREAKPOINT = 750;
  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function constrainTooltipToViewport(tooltip) {
    var rect = tooltip.getBoundingClientRect();
    var pad = 8;
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var nudgeX = 0;
    var nudgeY = 0;
    if (rect.left < pad) nudgeX = pad - rect.left;
    else if (rect.right > vw - pad) nudgeX = vw - pad - rect.right;
    if (rect.top < pad) nudgeY = pad - rect.top;
    else if (rect.bottom > vh - pad) nudgeY = vh - pad - rect.bottom;
    if (nudgeX !== 0) tooltip.style.setProperty('--tooltip-nudge', nudgeX + 'px');
    else tooltip.style.removeProperty('--tooltip-nudge');
    if (nudgeY !== 0) tooltip.style.setProperty('--tooltip-nudge-y', nudgeY + 'px');
    else tooltip.style.removeProperty('--tooltip-nudge-y');
  }

  function initHotspots(sectionEl) {
    if (!sectionEl) return;
    var triggers = sectionEl.querySelectorAll('[data-hotspot-trigger]');
    var tooltips = sectionEl.querySelectorAll('[data-hotspot-tooltip]');
    var mobileSlot = sectionEl.querySelector('.product-hotspot__mobile-slot');
    var mobileSlotInner = mobileSlot ? mobileSlot.querySelector('.product-hotspot__mobile-slot-inner') : null;

    function updateMobileSlot(tooltip, show) {
      if (!mobileSlot || !mobileSlotInner) return;
      if (!show) {
        mobileSlot.hidden = true;
        mobileSlot.setAttribute('aria-hidden', 'true');
        mobileSlotInner.innerHTML = '';
        return;
      }
      var inner = tooltip ? tooltip.querySelector('.product-hotspot__tooltip-inner') : null;
      if (inner) {
        mobileSlotInner.innerHTML = inner.innerHTML;
        mobileSlot.hidden = false;
        mobileSlot.setAttribute('aria-hidden', 'false');
      }
    }

    function closeAll() {
      tooltips.forEach(function (t) {
        t.style.removeProperty('--tooltip-nudge');
        t.style.removeProperty('--tooltip-nudge-y');
        t.classList.remove('product-hotspot__tooltip--open');
        t.setAttribute('aria-hidden', 'true');
      });
      triggers.forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
      });
      if (isMobile()) updateMobileSlot(null, false);
    }
    function openTooltip(tooltip, trigger) {
      tooltip.style.removeProperty('--tooltip-nudge');
      tooltip.style.removeProperty('--tooltip-nudge-y');
      tooltip.classList.add('product-hotspot__tooltip--open');
      tooltip.setAttribute('aria-hidden', 'false');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      if (isMobile()) {
        updateMobileSlot(tooltip, true);
      } else {
        requestAnimationFrame(function () {
          constrainTooltipToViewport(tooltip);
        });
      }
    }
    function constrainOpenTooltips() {
      if (isMobile()) return;
      tooltips.forEach(function (t) {
        if (t.classList.contains('product-hotspot__tooltip--open')) constrainTooltipToViewport(t);
      });
    }
    function runConstrainWhenReady() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          constrainOpenTooltips();
        });
      });
    }
    if (isMobile()) {
      tooltips.forEach(function (tooltip) {
        if (tooltip.classList.contains('product-hotspot__tooltip--open')) {
          updateMobileSlot(tooltip, true);
        }
      });
    } else {
      tooltips.forEach(function (tooltip) {
        if (tooltip.classList.contains('product-hotspot__tooltip--open')) {
          requestAnimationFrame(function () {
            requestAnimationFrame(constrainOpenTooltips);
          });
        }
      });
      if (document.readyState === 'complete') {
        runConstrainWhenReady();
        setTimeout(constrainOpenTooltips, 150);
        setTimeout(constrainOpenTooltips, 400);
      } else {
        window.addEventListener('load', function () {
          runConstrainWhenReady();
          setTimeout(constrainOpenTooltips, 150);
        });
      }
    }
    window.addEventListener('resize', function () {
      if (isMobile()) {
        var openTooltip = sectionEl.querySelector('.product-hotspot__tooltip--open');
        if (openTooltip) updateMobileSlot(openTooltip, true);
        else updateMobileSlot(null, false);
      } else {
        constrainOpenTooltips();
      }
    });
    triggers.forEach(function (btn) {
      var id = btn.getAttribute('data-hotspot-trigger');
      var tooltip = sectionEl.querySelector('[data-hotspot-tooltip="' + id + '"]');
      if (!tooltip) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = tooltip.classList.contains('product-hotspot__tooltip--open');
        closeAll();
        if (!isOpen) {
          openTooltip(tooltip, btn);
        }
      });
    });
    sectionEl.addEventListener('click', function (e) {
      if (e.target.closest('.product-hotspot__pin-btn') || e.target.closest('.product-hotspot__tooltip') || e.target.closest('.product-hotspot__mobile-slot')) return;
      closeAll();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  }
  document.querySelectorAll('.product-hotspot').forEach(initHotspots);
})();
